import React from 'react';

const Twilio = () => {
  return (
    <>
      <h5>
        <b>Twilio SMS</b>
      </h5>
      <br />
    </>
  );
};

export default Twilio;
